module.exports = __webpack_public_path__ + "img/index_logo2x.904e3e2f.png";